var _path, _rect, _g, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 357,
    viewBox: "0 0 485 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.615 3.36572H26.5518C13.7111 3.36572 3.30176 13.7751 3.30176 26.6157V324.097C3.30176 336.937 13.7111 347.347 26.5518 347.347H392.408C405.142 347.347 415.507 337.103 415.656 324.369L418.791 57.0621C418.942 44.1157 408.489 33.5395 395.542 33.5395H166.788C158.456 33.5395 151.702 26.7849 151.702 18.4526C151.702 10.1204 144.947 3.36572 136.615 3.36572Z",
    fill: "#3B4787",
    stroke: "#3B4787",
    strokeWidth: 4.86463
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.7466,
    y: 13.0566,
    width: 114.275,
    height: 16.9568,
    rx: 7.29695,
    fill: "#727AA6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_35442)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 235.283,
    height: 374.827,
    rx: 18.5983,
    transform: "matrix(0.00272858 -0.999996 0.999996 0.00270849 23.811 291.811)",
    fill: "#FCFAF9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13_35442)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13_35442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3598 293.438C30.1951 291.96 23.1622 282.522 24.6512 272.359L56.2402 56.7594C57.7292 46.5964 67.1764 39.556 77.341 41.0343L395.109 87.2495C405.273 88.7278 412.306 98.165 410.817 108.328L379.228 323.928C377.739 334.091 368.292 341.131 358.127 339.653L40.3598 293.438Z",
    fill: "#FCFAF9"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 101.619,
    height: 37.2088,
    rx: 5.47173,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 66.9946 293.472)",
    fill: "#E3E7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2 309.866C183.209 309.431 181.14 306.654 181.578 303.664L212.384 93.4088C212.822 90.4188 215.602 88.3475 218.592 88.7824L294.359 99.8017C297.349 100.237 299.418 103.013 298.98 106.003L268.174 316.258C267.736 319.248 264.957 321.32 261.966 320.885L186.2 309.866Z",
    fill: "#EBE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.047 142.942C285.057 142.507 282.987 139.73 283.426 136.74L288.16 104.43C288.598 101.44 291.377 99.3687 294.368 99.8036L314.207 102.689C317.198 103.124 319.267 105.9 318.829 108.89L314.095 141.201C313.657 144.191 310.877 146.262 307.887 145.827L288.047 142.942Z",
    fill: "#EBE9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.619,
    height: 7.29224,
    rx: 3.64612,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 133.607 304.06)",
    fill: "#E3E7EE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.848,
    height: 7.29224,
    rx: 3.64612,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 148.045 306.155)",
    fill: "#E3E7EE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.8825,
    height: 7.29224,
    rx: 3.64612,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 151.778 180.038)",
    fill: "#E3E7EE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.5988,
    height: 7.29224,
    rx: 3.64612,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 159.943 124.313)",
    fill: "#EBE9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.7994,
    height: 7.29224,
    rx: 3.64612,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 166.225 182.138)",
    fill: "#E3E7EE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.6991,
    height: 7.29224,
    rx: 3.64612,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 174.381 126.422)",
    fill: "#EBE9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.619,
    height: 7.29224,
    rx: 3.64612,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 314.298 328.505)",
    fill: "#E3E7EE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81.7477,
    height: 7.29224,
    rx: 3.64612,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 328.727 330.599)",
    fill: "#E3E7EE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 19.2017,
    ry: 19.2698,
    transform: "matrix(0.144969 -0.989436 0.989589 0.143923 117.546 94.9894)",
    fill: "#EBE9E9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M459.229 112H90.6239C80.5862 112 71.6786 118.452 68.538 127.985L6.0617 317.641C1.10723 332.68 12.3031 348.184 28.1381 348.184H392.838C402.718 348.184 411.519 341.94 414.783 332.615L481.174 142.931C486.465 127.814 475.245 112 459.229 112Z",
    fill: "#29315D",
    stroke: "#29315D",
    strokeWidth: 4.86463
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_35442",
    x: 13.7659,
    y: 56.5791,
    width: 395.559,
    height: 256.389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.0959
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.04797
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_35442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_35442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_35442",
    x: 16.1862,
    y: 40.8384,
    width: 403.096,
    height: 315.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.26592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.13296
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_35442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_35442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13_35442",
    x: 17.1565,
    y: 33.5427,
    width: 408.451,
    height: 320.898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.64782,
    dy: 3.64782
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.47173
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_35442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_35442",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.044098f62d2e2ea56da610bbd9180b13.svg";
export { ForwardRef as ReactComponent };